import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notificationService } from "./notification.service";

const initialState = {
  notification: { bespokeHFNotificationSuccess: false, loading: false },
};

export const sendBespokeHFNotification = createAsyncThunk(
  "/notification/sendBespokeHFNotification",
  async (data, thunkAPI) => {
    const response = await notificationService.sendBespokeHFNotification(data);
    return response.data;
  }
);

export const sendNoProductConsultantNotification = createAsyncThunk(
  "/notification/sendNoProductConsultantNotification",
  async (data, thunkAPI) => {
    const response =
      await notificationService.sendNoProductConsultantNotification(data);
    return response.data;
  }
);

export const sendSpeakToConsultantNotification = createAsyncThunk(
  "/notification/sendSpeakToConsultantNotification",
  async (data, thunkAPI) => {
    const response =
      await notificationService.sendSpeakToConsultantNotification(data);
    return response.data;
  }
);

export const sendReview = createAsyncThunk(
  "/notification/sendreview",
  async (data, thunkAPI) => {
    const response = await notificationService.sendReviewNotification(data);
    return response.data;
  }
);

export const sendDontKnowWhatIWantNotification = createAsyncThunk(
  "/notification/sendDontKnowWhatIWantNotification",
  async (data, thunkAPI) => {
    const response =
      await notificationService.sendDontKnowWhatIWantNotification(data);
    return response.data;
  }
);

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  extraReducers: {
    [sendBespokeHFNotification.fulfilled]: (state, action) => {
      state.notification = {
        loading: false,
        bespokeHFNotificationSuccess: action.payload.success,
      };
    },
    [sendBespokeHFNotification.pending]: (state, action) => {
      state.notification = { loading: true };
    },
    [sendBespokeHFNotification.rejected]: (state, action) => {
      state.notification = { loading: false };
    },
    [sendSpeakToConsultantNotification.fulfilled]: (state, action) => {
      state.notification = {
        loading: false,
        speakToConsultantNotificationSuccess: action.payload.success,
      };
    },
    [sendSpeakToConsultantNotification.pending]: (state, action) => {
      state.notification = { loading: true };
    },
    [sendSpeakToConsultantNotification.rejected]: (state, action) => {
      state.notification = { loading: false };
    },
    [sendNoProductConsultantNotification.fulfilled]: (state, action) => {
      state.notification = {
        loading: false,
        speakToConsultantNotificationSuccess: action.payload.success,
      };
    },
    [sendNoProductConsultantNotification.pending]: (state, action) => {
      state.notification = { loading: true };
    },
    [sendNoProductConsultantNotification.rejected]: (state, action) => {
      state.notification = { loading: false };
    },
    [sendReview.fulfilled]: (state, action) => {
      state.notification = {
        loading: false,
        speakToConsultantNotificationSuccess: action.payload.success,
      };
    },
    [sendReview.pending]: (state, action) => {
      state.notification = { loading: true };
    },
    [sendReview.rejected]: (state, action) => {
      state.notification = { loading: false };
    },
    [sendDontKnowWhatIWantNotification.fulfilled]: (state, action) => {
      state.notification = {
        loading: false,
        dontKnowWhatIWantNotificationSuccess: action.payload.success,
      };
    },
    [sendDontKnowWhatIWantNotification.pending]: (state, action) => {
      state.notification = { loading: true };
    },
    [sendDontKnowWhatIWantNotification.rejected]: (state, action) => {
      state.notification = { loading: false };
    },
  },
});

export default notificationSlice.reducer;
